module.exports = __webpack_public_path__ + "static/media/add_box_active.d9b962b1.svg";